"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENTS_MAP = void 0;
const ALGOLIA_EVAC_SEGMENT_5_1 = require("./ALGOLIA_EVAC_SEGMENT_5");
exports.SEGMENTS_MAP = new Map([["ALGOLIA_EVAC_SEGMENT_5", ALGOLIA_EVAC_SEGMENT_5_1.ALGOLIA_EVAC_SEGMENT_5]]);
//# sourceMappingURL=index.js.map